import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { Box, Button, Chip, Divider, Grid, IconButton, Paper, TextField } from '@material-ui/core';
import EditIcon from '@mui/icons-material/Edit';
import { Autocomplete, Card, Stack } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Checkbox from '@mui/material/Checkbox';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import SaveIcon from '@mui/icons-material/Save';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

import CheckBoxIcon from '@mui/icons-material/CheckBox';




import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { parsedEntitiyData } from '../../../../utils/utils';
import { getUsersList, putDataYaml } from '../../../../services/generalService';
import CircularProgressStack from '../../../../shared/components/CircularProgress/CircularProgress';

const UsersPage = () => {
    const config = useApi(configApiRef);
    const catalogApi = useApi(catalogApiRef);

    const [isLoading, setIsLoading] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [originalList, setOriginalList] = useState<any>();
    const [teamList, setTeamList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [currentRoles, setCurrentRoles] = useState([]);
    const [currentTeams, setCurrentTeams] = useState([]);
    const [newCurrentRoles, setNewCurrentRoles] = useState([]);
    const [newCurrentTeams, setNewCurrentTeams] = useState([]);

    const [openEditor, setOpenEditor] = useState(false);
    const [selectedUser, setSelectedUser] = useState<any | null>(null);


    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;


    // Funcionalidades X

    function stringToColor(string: string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }

    function stringAvatar(name: string) {
        return {
            sx: {
                bgcolor: stringToColor(name),
            },
            children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
        };
    }

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    }));

    // Mis funcionalidades
    const getEntitiesByType = async ({ kind, type }: { kind: string, type?: string }) => {
        try {
            const newFilter: any = {
                kind: kind,
            };
            if (type) {
                newFilter["spec.type"] = type;
            }
            const response = await catalogApi.getEntities({
                filter: { ...newFilter }
            });
            return response.items || [];
        } catch (error) {
            console.error('Error fetching data list:', error);
            return [];
        };
    };

    const loaderDataEntities = async () => {
        const resultRoles = await parsedEntitiyData(await getEntitiesByType({ kind: 'Group', type: 'rol' }));
        const resultTeams = await parsedEntitiyData(await getEntitiesByType({ kind: 'Group', type: 'team' }));
        setTeamList(resultTeams);
        setRoleList(resultRoles);
    };
    const loaderDataUsers = async () => {
        const resultUsers = await getUsersList(config);
        setDataList(parsedEntitiyData(resultUsers));
        setOriginalList(resultUsers);
        if (resultUsers) setIsLoading(false);
    };

    const handleChangeUser = (_event: any, newValue: any) => {
        setSelectedUser(newValue);
        setOpenEditor(false);
        const { rolesOfUser, teamsOfUser } = enhancedVersion(newValue);
        setCurrentRoles(rolesOfUser);
        setCurrentTeams(teamsOfUser);
        setNewCurrentRoles(rolesOfUser);
        setNewCurrentTeams(teamsOfUser);
        // Aquí puedes manejar el cambio de usuario seleccionado
    }

    const enhancedVersion = (dataUser: any) => {
        const rolesOfUser = dataUser.memberOf
            .map((member: any) =>
                roleList.find((role: any) => role.name === member)
            )
            .filter(Boolean); // Remover undefined/null
        const teamsOfUser = dataUser.memberOf
            .map((member: any) =>
                teamList.find((team: any) => team.name === member)
            )
            .filter(Boolean); // Remover undefined/null
        return { rolesOfUser, teamsOfUser };
    };

    const handleChangeRole = (_event: any, newValue: any) => {
        setNewCurrentRoles(newValue);
    };
    const handleChangeTeams = (_event: any, newValue: any) => {
        setNewCurrentTeams(newValue);
    };

    const handleEditUser = () => {
        setOpenEditor(true);
    }
    const handleCancel = () => {
        setOpenEditor(false);
    }

    const handleSaveData = async () => {
        setIsLoading(true);
        let newDataUser: any = [];
        newDataUser = originalList.map((item: any) => {
            if (item.metadata.name === selectedUser.name) {
                return {
                    ...item,
                    spec: {
                        ...item.spec,
                        memberOf: [
                            ...newCurrentRoles.map((role: any) => role.name),
                            ...newCurrentTeams.map((team: any) => team.name)
                        ]
                    }
                };
            }
            return item;
        });
        const body = {
            config,
            pathFile: 'da-users.yaml',
            content: newDataUser
        }
        const res = await putDataYaml(body);
        if (res) {
            loaderDataUsers();
            setSelectedUser({
                ...selectedUser,
                memberOf: [
                    ...newCurrentRoles.map((role: any) => role.name),
                    ...newCurrentTeams.map((team: any) => team.name)
                ]
            });
            handleChangeUser(null, {
                ...selectedUser,
                memberOf: [
                    ...newCurrentRoles.map((role: any) => role.name),
                    ...newCurrentTeams.map((team: any) => team.name)
                ]
            });
            setOpenEditor(false);
        };
        setIsLoading(false);
    };

    useEffect(() => {
        setIsLoading(true);
        loaderDataEntities();
        loaderDataUsers();
    }, []);

    return (
        <Grid container spacing={4}>
            {isLoading &&
                <CircularProgressStack />
            }
            <Grid item xs={12}>
                <Item>
                    <Typography variant="h4" sx={{ mt: 3 }} gutterBottom>
                        Search user
                    </Typography>
                    <Autocomplete
                        id="auto-complete-users"
                        sx={{ width: '90%', margin: 'auto', mb: 2 }}
                        size='medium'
                        options={dataList}
                        autoHighlight
                        getOptionLabel={(option: any) => option.displayName}
                        renderOption={(props, option) => {
                            const { key, ...optionProps } = props;
                            return (
                                <ListItem
                                    dense
                                    key={option.name}
                                    {...optionProps}
                                    disablePadding
                                >
                                    <ListItemAvatar>
                                        <Avatar
                                            {...stringAvatar(option.displayName)}
                                            alt={`${option.displayName}`}
                                            src={`/static/images/avatar/${option.picture + 1}.jpg`}
                                        />
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={`${option.displayName}`}
                                        secondary={`${option.email}`}
                                    />
                                </ListItem>
                            );
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Choose a user"
                            />
                        )}
                        onChange={(e, newValue) => {
                            handleChangeUser(e, newValue ? newValue : null);
                        }}
                    />
                    {
                        selectedUser && (
                            // <Item>
                            <Card variant="outlined" sx={{ width: '90%', margin: '50px auto', backgroundColor: '#fff', bgcolor: '#fff' }}>
                                <Box sx={{ p: 2 }}>
                                    <Stack
                                        direction="row"
                                        sx={{ alignContent: 'center', alignItems: 'center', gap: 2, justifyContent: 'space-between' }}
                                    >
                                        <Avatar
                                            {...stringAvatar(selectedUser.displayName)}
                                            alt={`${selectedUser.displayName}`}
                                            src={`/static/images/avatar/${selectedUser.picture + 1}.jpg`}
                                        />
                                        <Typography variant="h6" component="div">
                                            {selectedUser.displayName}
                                            <Typography variant="subtitle1" component="div" color="text.secondary">
                                                {selectedUser.email}
                                            </Typography>
                                        </Typography>
                                        <IconButton aria-label="editUser" color="primary" onClick={handleEditUser}>
                                            <EditIcon />
                                        </IconButton>
                                    </Stack>
                                </Box>
                                <Divider />
                                <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                                    <Box sx={{ p: 2, width: '50%', display: 'flex', }}>
                                        <Stack direction="column" spacing={1} alignItems={'flex-start'}>
                                            <Typography variant="h6"> Roles</Typography>
                                            {
                                                currentRoles.map((role: any) =>
                                                    <Chip key={role} color="primary" label={role.title} size="small" />
                                                )
                                            }
                                        </Stack>
                                    </Box>
                                    <Divider orientation="vertical" variant="middle" flexItem />
                                    {/* <Divider /> */}
                                    <Box sx={{ p: 2, width: '50%', display: 'flex', }}>
                                        <Stack direction="column" spacing={1} alignItems={'flex-start'}>
                                            <Typography gutterBottom variant="h6">
                                                Grupos
                                            </Typography>
                                            {
                                                currentTeams.map((group: any) =>
                                                    <Chip key={group} color="secondary" label={group.title} size="small" />
                                                )
                                            }
                                        </Stack>
                                    </Box>
                                </div>

                            </Card>

                        )}
                </Item>
            </Grid>
            {
                openEditor && (
                    <>
                        <Grid item xs={12}>
                            <Item sx={{ display: 'flex', width: '100%', flexDirection: 'column' }} >
                                <div style={{ display: 'flex', width: '100%', flexDirection: 'row' }}>

                                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: '45%' }}>
                                        <Typography variant="h4" sx={{ mt: 2, mb: 2 }} gutterBottom>
                                            Role selection
                                        </Typography>
                                        {/*{/* <TransferList /> */}
                                        <Autocomplete
                                            sx={{ width: '90%', margin: '20px auto' }}
                                            size="medium"
                                            multiple
                                            value={newCurrentRoles}
                                            // disabled={newData?.rol !== null && newData?.user.value !== null && !disableTeamsSelector ? false : true}
                                            onChange={handleChangeRole}
                                            id="checkboxes-roles"
                                            options={roleList}
                                            disableCloseOnSelect
                                            getOptionLabel={(option: any) => option.title}
                                            renderOption={(props, option: any, { selected }, index) => {
                                                const { key, ...optionProps } = props;
                                                return (
                                                    <li key={`${key}-${index}`} {...optionProps}>
                                                        <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={selected}
                                                        />
                                                        {option.title}
                                                    </li>
                                                );
                                            }}
                                            // style={{ width: 500 }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Roles" placeholder="Select the role to assign" />
                                            )}
                                        />
                                    </div>
                                    <Divider orientation="vertical" variant="middle" flexItem />
                                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: '49%' }}>
                                        <Typography variant="h4" sx={{ mt: 2, mb: 2 }} gutterBottom>
                                            Team selection
                                        </Typography>
                                        <Autocomplete
                                            sx={{ width: '90%', margin: '20px auto' }}
                                            size="medium"
                                            multiple
                                            value={newCurrentTeams}
                                            // disabled={newData?.rol !== null && newData?.user.value !== null && !disableTeamsSelector ? false : true}
                                            onChange={handleChangeTeams}
                                            id="checkboxes-groups"
                                            options={teamList}
                                            disableCloseOnSelect
                                            getOptionLabel={(option: any) => option.title}
                                            renderOption={(props, option: any, { selected }, index) => {
                                                const { key, ...optionProps } = props;
                                                return (
                                                    <li key={`${key}-${index}`} {...optionProps}>
                                                        <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={selected}
                                                        />
                                                        {option.title}
                                                    </li>
                                                );
                                            }}
                                            // style={{ width: 500 }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Roles" placeholder="Select the role to assign" />
                                            )}
                                        />
                                    </div>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    width: '100%',
                                    flexDirection: 'row',
                                    margin: '20px 0',
                                    paddingRight: 20,
                                    gap: 10,
                                    justifyContent: 'flex-end'
                                }}>
                                    <Button variant="outlined" onClick={handleCancel}>Cancel</Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleSaveData}
                                        color='primary'>
                                        <SaveIcon sx={{ mr: 1 }} /> Save
                                    </Button>
                                </div>
                            </Item>
                        </Grid>
                    </>
                )
            }
        </Grid >

    );
};

export default UsersPage;
